import { render, staticRenderFns } from "./VrstaPrometaCreate.vue?vue&type=template&id=79a39334&scoped=true&"
import script from "./VrstaPrometaCreate.vue?vue&type=script&lang=js&"
export * from "./VrstaPrometaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a39334",
  null
  
)

export default component.exports